<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-left col-md-9">
                        <div class="font-weight-bold body-1 courses-read-main-container">
                            {{ this.form.title }}
                            <primary-button :props="saveBtnData" class=""></primary-button>  
                        </div>
                    </v-col>
                   
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="9">
                        <CourseItemDetail :course="form">
                            
                        </CourseItemDetail>
                    </v-col>
                    
                </v-row>

            </div>

            <!-- <v-row justify="center" align="end" v-if="!showRichButtons">
				<v-col cols="12" md="9" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <secondary-button :props="saveDraftBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row> -->

           
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../../helpers/Utils';
import CourseItemDetail from './CourseItemDetail.vue';
// import DepForm from "./Form.vue";
export default {
    components: {
        // 'comp-form': DepForm,
        CourseItemDetail
    },
	data(){
		return {
            id: this.$route.params.id,
            step: '1',
            courseName: "nombre del curos",
           
            stepClasses: {st1: '', st2: '', st3: '', st4: ''},
            loading: false,
            serverErrors: {},
            showRichButtons:false,
            idLesson:-1,
            indexSectionSelected: -1,
            indexLessonSelected: -1,
            form: {
                title: "",
                brief_description:"",
                duration: "",
                summary: "",
                description: "",
                what_you_will_learn: "",
                sections:[
                    // {
                    //     title: '',
                    //     lessons: [
                    //         {
                    //             title:'',
                    //             type: 'LECCIÓN',
                    //             has_content:false,
                    //         }
                    //     ]
                    // }
                ],
                list_companies:[],
                draft:0,
                image_file: [],
                update_image_file: [],
                image_url: "",
                sections_to_delete: [],
                lessons_to_delete: [],

                images_data:[
                    // {id, url}
                ]
                // _method: "POST",
            },
          
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Courses",	
                block:false,
                click: () => {}
            },
           
            saveBtnData: {
                text: "Comenzar",
                icon: "",	
                click: () => {this.startCourse()},
                block:false,
                loading: false,
            },
            
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        onResize () {
            
            // if(window.innerWidth < 600){
            //     this.saveBtnData.block = true;
            //     this.cancelBtnData.block = true;
            // }
            // else{
            //     this.saveBtnData.block = false;
            //     this.cancelBtnData.block = false;
            // }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate()
		},
       

        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.course.getCourse(this.id)
			.then((response) => {
                this.form.title = response.data.title;
                this.form.brief_description = response.data.brief_description;
                this.form.duration = response.data.duration;
                this.form.summary = response.data.summary;
                this.form.description = response.data.description;
                this.form.what_you_will_learn = response.data.what_you_will_learn;
                this.form.sections =response.data.sections;
                this.form.list_companies = response.data.companies.map((x) => {
                    return {text: x.name, value: x.id}
                });
                this.form.draft = response.data.draft == true ? 1 : 0;
                this.form.image_file = [];
                this.form.image_url = response.data?.image?.url??'';

                for (let i = 0; i < this.form.sections.length; i++) {
                    this.form.sections[i]
                    for (let index = 0; index < this.form.sections[i].lessons.length; index++) {
                        this.form.sections[i].lessons[index].type = this.form.sections[i].lessons[index].content_type;
                        
                    }
                    
                }


			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
		},


        startCourse(){
            this.$router.push({ name: 'ReadCourseProgress', params: { id: this.id }}).catch(()=>{});
        },


        setStateLoading(draftMode, value){
            if(!draftMode){
                this.saveBtnData.loading = value;
            }else{
                this.saveDraftBtnData.loading = value;
            }
        },



        getLessonBody(){
            this.$api.course.getCourse(this.id)
			.then((response) => {
               

                let body = response.data.sections[this.indexSectionSelected].lessons[this.indexLessonSelected];
                body['type'] = body.content_type;
                this.form.sections[this.indexSectionSelected].lessons[this.indexLessonSelected] = body;

                console.log(this.form, "form final")
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
                this.closeRich(false);
			})
        },


        
    },
}
</script>

<style lang="scss">
  


</style>